import React, { useEffect, useState } from "react";
import { StyleSheet, View, Text, Platform } from "react-native";

import moment from "moment";
import { min } from "lodash";

import Icons from "../../common/icons";
import Utils from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

import ReflectionHelper from "../ReflectionHelper";
const DATE_FORMAT = "YYYY-MM-DD";

export default function SelectedInterval({
  controller,
  reflection,
  reflectionHours,
  onIntervalChanged = () => {},
  showTutorials = false,
}) {
  const [showBackIcon, setShowBackIcon] = useState(false);
  const [showForwardIcon, setShowForwardIcon] = useState(false);
  const [intervalName, setIntervalName] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [timeUnit, setTimeUnit] = useState("week");

  const now = Utils.nowUserTz(controller);

  useEffect(() => {
    const tu = reflection.edit_time_unit || "week";
    const dt = moment(reflection.edit_day);

    setTimeUnit(tu);
    setSelectedDate(dt);
    setIntervalName(
      ReflectionHelper.getPeriodDisplayText(reflection.edit_day, tu),
    );

    const lastEntryDate = moment(min(Object.keys(reflectionHours)));
    setShowBackIcon(dt.diff(lastEntryDate, `${tu}s`) > 0);
    setShowForwardIcon(now.diff(dt, `${tu}s`) > 0);
  }, [reflection]);

  const changeInterval = (offset, isEnabled = true) => {
    if (!isEnabled || showTutorials) return;

    //  Add 1 week/day/year
    let newDate = selectedDate
      .clone()
      .add(offset, timeUnit)
      .startOf(timeUnit === "week" ? "isoWeek" : timeUnit);

    const selectedDay = moment(newDate).format(DATE_FORMAT);
    const hours = reflectionHours[selectedDay] || {};

    const data = {
      time_unit: timeUnit,
      day: selectedDay,
      id: hours.gem?.id,
      mood: hours.gem?.mood,
      text: hours.gem?.text,
      hours: hours.hours || 0,
    };

    setSelectedDate(newDate);
    onIntervalChanged(data);
  };

  return (
    <View
      style={{
        zIndex: 100,
      }}
    >
      <View style={styles.intervalContainer}>
        <Text style={styles.intervalText}>{intervalName}</Text>

        <View style={styles.rightContainer}>
          <Icons.ArrowLeft
            style={[styles.arrowLeft]}
            fillColor={showBackIcon ? AppTheme.almostBlack : "#ABADB3"}
            onPress={() => changeInterval(-1, showBackIcon)}
          />

          <Icons.ArrowRight
            style={[styles.arrowRight]}
            fillColor={showForwardIcon ? AppTheme.almostBlack : "#ABADB3"}
            onPress={() => changeInterval(1, showForwardIcon)}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  intervalContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  intervalText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  rightContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    height: 40,
  },
});
